import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initTheme } from './config/theme.js'
import './styles/global.css'
import './styles/utilities.css'

// Initialize theme before mounting app
initTheme()

createApp(App).use(router).mount('#app')
